import React from 'react';
import styles from './ProgramCode.module.scss';

const ProgramCode = ({ programCode }) => {
    return <span className={styles.eventId}>{programCode}</span>;
};

export default ProgramCode;
